import {ReduxState} from '../reducer';

const data = (state: ReduxState) => state.dashboard.data;
const loading = (state: ReduxState) => state.dashboard.loading;
const rates = (state: ReduxState) => state.dashboard.rates;
const yearlyRevenue = (state: ReduxState) => state.dashboard.yearlyRevenue;

const DashboardSelector = {
    data,
    loading,
    rates,
    yearlyRevenue,
};

export default DashboardSelector;
